var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNopreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 152,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "nopreview_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 153,
    height: 152
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h152v152H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nopreview_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.234 124.767c-2.744 0-5.014-.898-6.808-2.692-1.794-1.794-2.692-4.064-2.692-6.808V36.733c0-2.744.898-5.014 2.692-6.808 1.795-1.794 4.064-2.692 6.808-2.692h78.534c2.744 0 5.014.898 6.808 2.692 1.794 1.794 2.692 4.064 2.692 6.808v78.534c0 2.744-.898 5.014-2.692 6.808-1.794 1.794-4.064 2.692-6.808 2.692H37.234zm0-4.434h78.534c1.266 0 2.427-.527 3.483-1.583s1.583-2.217 1.583-3.483V36.733c0-1.266-.527-2.427-1.583-3.483s-2.217-1.583-3.483-1.583H37.234c-1.266 0-2.427.527-3.483 1.583-1.055 1.056-1.583 2.217-1.583 3.483v78.534c0 1.266.528 2.427 1.583 3.483 1.056 1.056 2.217 1.583 3.483 1.583zm18.367-16.783h43.067c.95 0 1.636-.422 2.058-1.267.422-.844.369-1.689-.158-2.533l-11.4-15.358c-.528-.634-1.161-.95-1.9-.95-.74 0-1.373.316-1.9.95L71.434 101.65l-8.233-9.5c-.528-.528-1.135-.792-1.82-.792-.687 0-1.294.317-1.822.95l-5.7 7.442c-.633.844-.739 1.689-.316 2.533.422.845 1.108 1.267 2.058 1.267zm-1.267-44.333c1.478 0 2.745-.528 3.8-1.584 1.056-1.055 1.584-2.322 1.584-3.8 0-1.477-.528-2.744-1.584-3.8-1.055-1.055-2.322-1.583-3.8-1.583-1.477 0-2.744.528-3.8 1.583-1.055 1.056-1.583 2.323-1.583 3.8 0 1.478.528 2.745 1.583 3.8 1.056 1.056 2.323 1.584 3.8 1.584z",
    fill: "#000"
  }))));
}
export default SvgNopreview;